
export const initialValues = {
  gradeId: "",
  gradeListName: "",
  activeStatus: 1,

}